var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Switch/Swap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wicrypt Switch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M8.38182 16.1133C7.73668 16.1133 7.21442 16.6433 7.21442 17.2981L6.89258 23.0215C6.89258 23.8558 7.55966 24.5314 8.38182 24.5314C9.20397 24.5314 9.8696 23.8558 9.8696 23.0215L9.54922 17.2981C9.54922 16.6433 9.02696 16.1133 8.38182 16.1133Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M9.97546 4.59181C9.97546 4.59181 9.64045 4.24737 9.43272 4.09741C9.13136 3.8658 8.75978 3.75 8.38967 3.75C7.9742 3.75 7.58799 3.88065 7.27347 4.12711C7.21642 4.18501 6.97357 4.40326 6.77315 4.60666C5.51505 5.79588 3.45674 8.90033 2.82769 10.526C2.72821 10.7725 2.51317 11.3961 2.5 11.7301C2.5 12.0478 2.57022 12.3537 2.71358 12.6432C2.914 13.0054 3.22853 13.2964 3.60011 13.4553C3.85758 13.5577 4.62853 13.7166 4.64316 13.7166C5.48726 13.8769 6.85947 13.9631 8.37504 13.9631C9.81893 13.9631 11.1341 13.8769 11.9913 13.7463C12.006 13.7314 12.9627 13.5726 13.2919 13.3974C13.8917 13.0782 14.2647 12.4546 14.2647 11.788V11.7301C14.2501 11.2951 13.877 10.3805 13.8639 10.3805C13.2348 8.84242 11.276 5.81072 9.97546 4.59181Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    opacity: 0.4,
    d: "M21.6181 13.887C22.2633 13.887 22.7855 13.357 22.7855 12.7022L23.1059 6.97869C23.1059 6.14429 22.4403 5.46875 21.6181 5.46875C20.796 5.46875 20.1289 6.14429 20.1289 6.97869L20.4507 12.7022C20.4507 13.357 20.973 13.887 21.6181 13.887Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M27.2855 17.357C27.0851 16.9947 26.7706 16.7052 26.399 16.5449C26.1415 16.4424 25.3691 16.2836 25.3559 16.2836C24.5118 16.1232 23.1396 16.0371 21.624 16.0371C20.1802 16.0371 18.865 16.1232 18.0077 16.2539C17.9931 16.2687 17.0364 16.4291 16.7072 16.6028C16.106 16.922 15.7344 17.5456 15.7344 18.2137V18.2716C15.749 18.7066 16.1206 19.6197 16.1352 19.6197C16.7643 21.1579 18.7216 24.1911 20.0236 25.4086C20.0236 25.4086 20.3586 25.753 20.5664 25.9015C20.8663 26.1346 21.2378 26.2504 21.6109 26.2504C22.0249 26.2504 22.4096 26.1197 22.7256 25.8733C22.7827 25.8154 23.0255 25.5971 23.2259 25.3952C24.4826 24.2045 26.5423 21.0999 27.1699 19.4757C27.2709 19.2292 27.4859 18.6042 27.4991 18.2716C27.4991 17.9524 27.4289 17.6465 27.2855 17.357Z",
    fill: "#E5B910"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchSwap);
export default __webpack_public_path__ + "static/media/switch-swap.084624e815cee2f2a8430d36c70b37cf.svg";
export { ForwardRef as ReactComponent };